import React from 'react';

import { Assignee } from 'api/queries/getTopStartDateChanges.query';

import { AssigneeAvatar } from 'components/common/AssigneeAvatar/AssigneeAvatar';

import classes from './AvatarCell.module.scss';

interface Props {
    avatar: Assignee;
}

export const AvatarCell = ({ avatar }: Props) => {
    return (
        <div className={classes.avatarCell}>
            <AssigneeAvatar assignee={avatar} />
            <div>{`${avatar.firstName} ${avatar.lastName}`}</div>
        </div>
    );
};
